export interface ParagraphHighlightContextMenuItem {
    key: string;
    label: string;
    icon: string;
    callback: (text: string) => void;
}

export const ParagraphHighlightService = Symbol('ParagraphHighlightService');

export interface ParagraphHighlightService {
    updateContextMenu(): void;
}
